export default __webpack_public_path__ + "static/media/MaksymB280.14e4c97a.jpg";